import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['daysRadio', 'attendanceRadio', 'daysInput', 'attendanceInput']

  switch_type() {
    if ($(this.daysRadioTarget).is(':checked')) {
      $(this.daysInputTarget).removeClass('hidden')
      $(this.daysInputTarget).find('input').prop('required', true)
      $(this.attendanceInputTarget).addClass('hidden')
      $(this.attendanceInputTarget).find('input').prop('required', false)
    } else {
      $(this.daysInputTarget).addClass('hidden')
      $(this.daysInputTarget).find('input').prop('required', false)
      $(this.attendanceInputTarget).removeClass('hidden')
      $(this.attendanceInputTarget).find('input').prop('required', true)
    }
  }
}
